var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIc12YearsDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5432 8.46452C8.50251 12.9833 4.81865 23.8114 9.22081 32.6189C13.623 41.4263 24.4948 44.9792 33.5355 40.4604C41.0295 36.7148 44.85 28.6218 43.4198 20.9486C43.2324 19.9432 43.8956 18.9762 44.901 18.7888C45.9064 18.6014 46.8734 19.2646 47.0608 20.27C48.7929 29.5632 44.1673 39.287 35.1914 43.7734C24.3775 49.1784 11.2525 44.9678 5.90788 34.2747C0.563233 23.5817 5.07342 10.5567 15.8874 5.15159C24.9056 0.644059 35.517 2.82229 41.9009 9.86468C42.5878 10.6224 42.5304 11.7935 41.7726 12.4804C41.0149 13.1673 39.8438 13.1099 39.1569 12.3522C33.8864 6.53803 25.0728 4.70109 17.5432 8.46452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7941 34H13.6765V19.8857H11V17.5107C12.8529 17.5107 14.0196 16.7643 14.7059 15H17.7941V34ZM31.7941 30.1321V34H21.7745V29.9964C26.3039 23.8214 27.8137 22.7357 27.8137 20.3607C27.8137 19.4107 27.4706 18.8679 26.7157 18.8679C25.7549 18.8679 25.549 19.6143 25.549 20.4964V21.5821H21.7059V20.3607C21.7059 17.375 23.1471 15 26.7157 15C30.1471 15 32 17.1036 32 20.5643C32 24.6357 28.5686 27.2821 26.1667 30.1321H31.7941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 24C34 23.3627 34.5084 22.8462 35.1355 22.8462H36.8952V21.1613C36.8952 20.5199 37.4069 20 38.0381 20C38.6693 20 39.181 20.5199 39.181 21.1613V22.8462H40.8645C41.4916 22.8462 42 23.3627 42 24C42 24.6373 41.4916 25.1538 40.8645 25.1538H39.181V26.8387C39.181 27.4801 38.6693 28 38.0381 28C37.4069 28 36.8952 27.4801 36.8952 26.8387V25.1538H35.1355C34.5084 25.1538 34 24.6373 34 24Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc12YearsDark);
export default __webpack_public_path__ + "static/media/ic_12years_dark.ae10c83f1e437841aaf04d47f21c45c1.svg";
export { ForwardRef as ReactComponent };